import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { queryClient } from 'src/components/queryProvider';
import { generateQuery, requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

import { fetchWeekdayDayparts } from '../../weekdayDayparts';
import { mapScheduleDayparts } from './helper';

export const useGetScheduleDayparts = (
  filters: string[] = [],
  enabled = true,
) => {
  return useQuery({
    queryKey: queryKeys.scheduleDayparts.all(filters),
    queryFn: () => fetchScheduleDayparts(filters),
    enabled,
  });
};

export const fetchScheduleDayparts = async (filters: string[] = []) => {
  const url = `/scheduleDayparts${generateQuery(
    ['locationGroups'],
    concat(filters, 'pageSize=0'),
  )}`;

  const response = await requestCCApi({ url });

  const weekdayDayparts = await queryClient.fetchQuery({
    queryKey: queryKeys.weekdayDayparts.all(),
    queryFn: fetchWeekdayDayparts,
  });

  return mapScheduleDayparts(response, weekdayDayparts);
};
